import $ from 'jquery';
// import mpro from './mpro.init';
import '../../vendor/fancybox/core';
import '../../vendor/fancybox/fullscreen';
import '../../vendor/fancybox/guestures';
import '../../vendor/fancybox/media';
// import '../../vendor/fancybox/share';
import '../../vendor/fancybox/slideshow';
import '../../vendor/fancybox/thumbs';
import '../../vendor/fancybox/wheel';

// ============================
// Customize the fancy box plugin
// ============================
$.extend(true, $.fancybox.defaults || {}, {
	closeExisting: true,
	loop: true,
	keyboard: true,
	arrows: true,
	infobar: true,
	buttons: [
		'zoom',
		// 'share',
		'slideShow',
		'fullScreen',
		// "download",
		'thumbs',
		'close',
	],
	toolbar: true,
	hideScrollbar: true,
	autoFocus: true,
	backFocus: true,
	trapFocus: true,
	// Horizontal space between slides
	gutter: 0,
	// animationEffect: 'zoom-in-out',
	transitionEffect: 'tube',
	thumbs: {
		autoStart: true,
		hideOnClose: true,
		parentEl: '.fancybox-container',
		axis: 'y',
	},
	wheel: 'auto',
	slideShow: false,
	fullScreen: true,
	touch: {
		vertical: false,
		momentum: true,
	},

	// Protect an image from downloading by right-click
	protect: false,
	preventCaptionOverlap: false,
	idleTime: false,
	// beforeLoad: function (instance, item, firstRun) {
	// 	console.log(this);
	// 	console.log(instance);
	// 	console.log(item);
	// 	console.log(firstRun);
	// 	return false;
	// },
	// clickContent: function (current, e) {
	// 	if (e) {
	// 		// @ts-ignore
	// 		if (!this.$refs.container.hasClass('fancybox-is-zoomable')) {
	// 			return false;
	// 		}
	// 	}
	// 	return 'zoom';
	// },
	// clickSlide: function (current, e) {
	// 	if (e) {
	// 		// @ts-ignore
	// 		if (!this.$refs.container.hasClass('fancybox-is-zoomable')) {
	// 			return false;
	// 		}
	// 	}
	// 	return 'zoom';
	// },
	// clickOutside: false,
	dblclickContent: false,
	dblclickSlide: false,
	dblclickOutside: false,

	mobile: {
		preventCaptionOverlap: true,
		idleTime: false,
		clickContent: false,
		clickSlide: false,
		// clickOutside: false,
		dblclickContent: 'zoom',
		dblclickSlide: 'zoom',
		dblclickOutside: false,
	},
	image: {
		// Wait for images to load before displaying
		// Requires predefined image dimensions
		// If 'auto' - will zoom in thumbnail if 'width' and 'height' attributes are found
		preload: 'auto',
	},
	beforeClose(instance, current, e) {
		// Close dropdowns
		mpro.closeSimpleOverlays();

		// If trigger is inside splide, tigger a goto the new index
		if (instance.$trigger.closest('.splide').length) {
			const splide = instance.$trigger.closest('.splide').data('splide');
			const $instanceSplide = instance.$trigger.closest('.splide__slide');

			let index;
			if ($instanceSplide.length) {
				const $allSlides = $instanceSplide.parent().children();
				const $allSlidesContent = $allSlides.map(function(){ return $(this).children().first();});
				const $allSlidesContentWithoutFancyboxIgnore = $allSlidesContent.filter(function(){return (typeof this.data('ignoreFancybox') === 'undefined')});
				const selectedSlideContent = $allSlidesContentWithoutFancyboxIgnore[instance.currIndex];
				index = $allSlides.index($(selectedSlideContent).parent());
			}
			else {
				index = instance.currIndex;
			}

			if (splide) {
				// if (splide.options.thumbnails && $(splide.options.thumbnails).length) {
				// 	console.log($(splide.options.thumbnails).data('splide'));
				// 	$(splide.options.thumbnails).data('splide').Components.Controller.toIndex(index);
				// }

				splide.Components.Controller.go(index);
			}
		}
	},
	// afterClose: function (instance, current, e) {
	// 	// Close dropdowns
	// 	$('[data-toggle=dropdown][aria-expanded=true],[data-bs-toggle=dropdown][aria-expanded=true]').trigger('click');
	// },
	// Disable the hash module
	hash: false,
});

/**
 * Proper getInstance method for fancybox plugin
 *
 * @param {JQuery=} $elem
 * @param {*=} opt
 */
mpro.getFancyboxInst = function($elem, opt = {}) {
	// Get fancybox instance for elem
	if ($elem) {
		return $.fancybox.open(($elem instanceof $) ? $elem : $($elem), opt, 0);
	}

	// Get the currently active fancybox instance
	return $.fancybox.getInstance();
};

/**
 * @param {number=} duration
 */
mpro.closeAllFancyboxes = function(duration) {
	try {
		const fBox = mpro.getFancyboxInst();
		if (fBox && fBox.current.$content.is(':not(.shm-dialog,.shm-overlayer)')) {
			fBox.close(null, duration);
		}
	}
	catch (ex) {
		console.warn('Error closing FancyBox instance', ex);
	}
};

// Trigger the custom ready event
mpro.get$D().trigger('fancybox:ready');

export default mpro;
